const DASHBOARD_CONTAINER_ID = 'dashboard-wrapper';

const scrollDashboardInto = (block: 'end' | 'start' = 'end'): void => {
  document.getElementById(DASHBOARD_CONTAINER_ID)?.scrollIntoView({
    behavior: 'smooth',
    block,
    inline: 'nearest',
  });
};

const scrollToBottomOfDashboard = (): void => scrollDashboardInto();

const scrollToTopOfDashboard = (): void => scrollDashboardInto('start');

export {
  DASHBOARD_CONTAINER_ID,
  scrollToTopOfDashboard,
  scrollToBottomOfDashboard,
};
